import * as pdfjs from "pdfjs-dist/legacy/build/pdf"

pdfjs.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/legacy/build/pdf.worker.entry")

export default pdfjs
